export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export const fetchWithRetry = async (url: string, timeLimit = 10000, waitFor = 200) => {
  let totalTime = 0
  let then
  let response
  while (totalTime < timeLimit) {
    then = Date.now()
    response = await fetch(url)
    if (response.ok && response.status !== 202) {
      return response
    } else {
      await delay(waitFor)
      totalTime += waitFor + (Date.now() - then)
    }
  }
  return response
}
